import { useTranslate } from '@tolgee/react';
import { OrderRow } from './OrderRow';
import { TradeCancelInfoData } from 'views/Conversation/Sider/hooks/useTradeCancelInfo';
import { useToggle } from 'ahooks';
import { useCallback, useMemo } from 'react';
import CancelApprovalBtns from 'views/Refund/components/CancelApprovalBtns';
import { Button } from 'antd';
import { useOrderCard } from './context';

interface OrderCancelProps {
  cancelInfo: TradeCancelInfoData;
  onUpdate: () => void;
}

export const OrderCancel = (props: OrderCancelProps) => {
  const { cancelInfo, onUpdate } = props;
  const { t } = useTranslate();
  const {
    cancelType,
    cancelReasonLabel,
    formattedModifiedTime,
    isCanceled,
    approvalBtnParams,
    showApprovalBtns,
  } = cancelInfo;
  const [opened, { toggle: toggleOpened }] = useToggle(!isCanceled);

  const { openOrderDrawer } = useOrderCard();

  const labelText = useMemo(() => {
    if (isCanceled) {
      return {
        label: t('orderStatus.COMPLETE'),
      };
    }
    if (cancelType) {
      return {
        color: cancelType === 'buyer' ? '#F05B5B' : undefined,
        label: t('trade.cancelRole', { role: t(`cancelType.${cancelType}`) }),
      };
    }
  }, [cancelType, isCanceled, t]);

  const Value = labelText ? (
    <span
      style={{
        color: labelText.color,
      }}
    >
      {labelText.label}
    </span>
  ) : null;

  const handleDetail = useCallback(() => {
    openOrderDrawer({
      entryType: 'cancel',
    });
  }, [openOrderDrawer]);

  return (
    <div className="flex flex-col gap-3">
      <OrderRow
        title={t('trade.cancel')}
        value={Value}
        showArrow
        onClick={toggleOpened}
        arrowDirection={opened ? 'up' : 'down'}
      />
      {opened && (
        <div className="bg-[#F7F9FA] rounded p-3 flex flex-col gap-1">
          <div className="text-[#232426]">{cancelReasonLabel}</div>
          <div className="text-xs text-[#84868C]">{formattedModifiedTime}</div>
          <div className="flex gap-2 justify-end flex-wrap mt-2">
            <Button
              className="!bg-[#ECECED] !border-none !text-[#515359] hover:opacity-80"
              size="small"
              onClick={handleDetail}
            >
              {t('feedback.详情')}
            </Button>
            {showApprovalBtns && (
              <CancelApprovalBtns
                {...approvalBtnParams}
                onUpdate={onUpdate}
                buttonProps={{ type: 'primary', size: 'small', className: '!ml-2' }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
